import { LANGUAGE_VARIANT_SEPARATOR } from '../constants/common'
import { DATE_LOCALES, DEFAULT_DATE_LOCALE } from '../constants/date'

/**
 * @param {string} language
 *
 * @returns {import('date-fns').Locale}
 */
export function getDateLocale(language) {
  return DATE_LOCALES.get(language) ?? DEFAULT_DATE_LOCALE
}

/**
 * A BCP 47 locale for the `Intl` APIs: the audience suffix of a UI language
 * (`de_in`) is not a valid subtag, so only the base language is kept.
 *
 * @param {string} language
 *
 * @returns {string}
 */
export function getIntlLocale(language) {
  return language.split(LANGUAGE_VARIANT_SEPARATOR)[0]
}
